import React from 'react';
import './ProfilePage.css';

const MY_WORKS = [
  { id: 1, title: '雨夜狂想曲', plays: '1.2k', likes: 342, date: '2天前', color: '#667eea' },
  { id: 2, title: '赛博朋克2077', plays: '892', likes: 120, date: '5天前', color: '#4ECDC4' },
  { id: 3, title: '午后阳光', plays: '2.5w', likes: 4500, date: '1周前', color: '#FFD93D' },
  { id: 4, title: '未命名草稿', plays: '56', likes: 2, date: '1周前', color: '#FF6B6B', isDraft: true },
];

function ProfilePage() {
  return (
    // Removed "h-scrollable" to enable global page swipe
    <div className="profile-page">
      <div className="profile-header">
        <div className="header-top">
          <button className="settings-btn"><i className="fas fa-cog"></i></button>
        </div>
        
        <div className="profile-info">
          <div className="avatar-wrapper">
            <div className="profile-avatar">我</div>
            <div className="vip-badge"><i className="fas fa-crown"></i></div>
          </div>
          <h2 className="profile-name">超级创造者</h2>
          <p className="profile-bio">AI 音乐探索者 | 电子/流行 | 合作私信</p>
          
          <div className="profile-stats">
            <div className="stat-item">
              <span className="stat-num">12</span>
              <span className="stat-label">作品</span>
            </div>
            <div className="stat-item">
              <span className="stat-num">3.5k</span>
              <span className="stat-label">关注</span>
            </div>
            <div className="stat-item">
              <span className="stat-num">1.2w</span>
              <span className="stat-label">粉丝</span>
            </div>
          </div>
        </div>
      </div>

      <div className="profile-content">
        <div className="content-tabs">
          <div className="content-tab active">作品</div>
          <div className="content-tab">收藏</div>
          <div className="content-tab">草稿箱</div>
        </div>

        <div className="works-list">
          {MY_WORKS.map(work => (
            <div key={work.id} className="work-item">
              <div className="work-cover" style={{ background: work.color }}>
                <i className="fas fa-play"></i>
                {work.isDraft && <span className="draft-tag">草稿</span>}
              </div>
              <div className="work-info">
                <h4 className="work-title">{work.title}</h4>
                <div className="work-meta">
                  <span><i className="fas fa-headphones"></i> {work.plays}</span>
                  <span><i className="fas fa-heart"></i> {work.likes}</span>
                </div>
              </div>
              <div className="work-action">
                <i className="fas fa-ellipsis-v"></i>
              </div>
            </div>
          ))}
        </div>
        
        {/* 底部垫高 */}
        <div style={{ height: 80 }}></div>
      </div>
    </div>
  );
}

export default ProfilePage;